import { AmplitudeCategories, createTrackerForCategory } from "./amplitude";

const trackEvent = createTrackerForCategory(AmplitudeCategories.ModifyWorkspaceUsers);

enum events {
    InviteUsersStart = "InviteUsersStart",
    InviteUsersComplete = "InviteUsersComplete",
    ModifyUserRole = "ModifyUserRole",
    ModifyInviteRole = "ModifyInviteRole",
    QuantityContraction = "QuantityContraction",
    QuantityExpansion = "QuantityExpansion"
}

async function _getBillingController() {
    // @ts-ignore
    return await import("js/controllers/BillingController").then(module => module.default);
}

export async function InviteUsersStart({ workspace_id }: { workspace_id: string }) {
    const eventProperties = {
        quantity_seats_available: (await _getBillingController()).availableSeatCount,
        workspace_id
    };

    trackEvent(events.InviteUsersStart, eventProperties, { audit: true });
}

export function InviteUsersComplete(props: {
    quantity_invites_sent: number;
    quantity_new_seats_added: number;
    invite_ids: string[];
}) {
    trackEvent(events.InviteUsersComplete, props, { audit: true });
}

export function ModifyUserRole(props: { affected_user_id: string, updated_role_from: string, updated_role_to: string }) {
    trackEvent(events.ModifyUserRole, props, { audit: true });
}

export function ModifyInviteRole(props: { affected_invite_id: string, updated_role_from: string, updated_role_to: string }) {
    trackEvent(events.ModifyInviteRole, props, { audit: true });
}

export function QuantityContraction(props: { quantity_seats_removed: number }) {
    trackEvent(events.QuantityContraction, props, { audit: true });
}

export function QuantityExpansion(props: { quantity_new_seats_added: number }) {
    trackEvent(events.QuantityExpansion, props, { audit: true });
}
